import { render, staticRenderFns } from "./Unsupported.vue?vue&type=template&id=6f899e2d&"
import script from "./Unsupported.vue?vue&type=script&lang=js&"
export * from "./Unsupported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports